export default {
    state: {
        display: localStorage.getItem('display') ?? 'LIST'
    },
    getters: {
        isDisplayGrid: state => {
            return state.display === 'GRID'
        },
        isDisplayList: state => {
            return state.display === 'LIST'
        },
    },
    mutations: {
        setDisplay(state, payload) {
            state.display = payload
        },
    },
    actions: {
        changeDisplayToGrid(context) {
            localStorage.setItem('display', 'GRID')
            context.commit('setDisplay', 'GRID')
        },
        changeDisplayToList(context) {
            localStorage.setItem('display', 'LIST')
            context.commit('setDisplay', 'LIST')
        },
    },
}
